// extracted by mini-css-extract-plugin
module.exports = {"body":"ReviewBudget-module__body--RNSYV","container":"ReviewBudget-module__container--5mVtA","title":"ReviewBudget-module__title--1-PVu"};